import React from 'react';
import { Button } from './ui/Button';
import { Check, Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 overflow-hidden" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center max-w-4xl mx-auto mb-10" data-id="element-53">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-coral-100 text-coral-700 text-xs md:text-sm font-bold mb-6 animate-pulse-slow" data-id="element-54">
            <Zap size={14} className="fill-current" data-id="element-55" />
            ACCESO INMEDIATO · SOLO HOY
          </div>

          <h1 className="text-4xl md:text-6xl font-serif font-bold text-dark-900 leading-tight mb-4" data-id="element-56">
            No es tu edad, es tu cortisol:
          </h1>
          <p className="text-2xl md:text-4xl font-serif text-coral-500 font-medium mb-8" data-id="element-57">
            Cómo desinflamar tu abdomen en 14 días
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-58">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-59">
            {/* Product Image */}
            <div className="w-full max-w-md relative z-10 transform hover:scale-105 transition-transform duration-500" data-id="element-60">
              <div className="absolute -inset-4 bg-coral-200/30 rounded-full blur-3xl opacity-50" data-id="element-61"></div>
              <img src="https://cdn.magicpatterns.com/uploads/vWEcL9gNaKxXUN2gE58VVa/maggic.png" alt="Protocolo Cortisol OFF en iPad" className="relative rounded-2xl shadow-2xl w-full" data-id="element-62" />
            </div>
          </div>

          {/* Trust Badges */}
          <div className="mt-10 flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-medium text-dark-800" data-id="element-63">
            <div className="flex items-center gap-2 bg-white/50 px-4 py-2 rounded-full shadow-sm" data-id="element-64">
              <Check size={18} className="text-sage-500" strokeWidth={3} data-id="element-65" />
              <span data-id="element-66">Sin suplementos costosos</span>
            </div>
            <div className="flex items-center gap-2 bg-white/50 px-4 py-2 rounded-full shadow-sm" data-id="element-67">
              <Check size={18} className="text-sage-500" strokeWidth={3} data-id="element-68" />
              <span data-id="element-69">Sin horas de cardio</span>
            </div>
            <div className="flex items-center gap-2 bg-white/50 px-4 py-2 rounded-full shadow-sm" data-id="element-70">
              <Check size={18} className="text-sage-500" strokeWidth={3} data-id="element-71" />
              <span data-id="element-72">Solo ciencia aplicada</span>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-73">
            <Button variant="primary" className="px-8 py-4 text-lg md:text-xl shadow-coral-500/30 shadow-xl hover:shadow-2xl transform hover:-translate-y-1" data-id="element-74">
              QUIERO EL PROTOCOLO POR $9.99 →
            </Button>
            <p className="mt-4 text-sm text-gray-500" data-id="element-75">
              Oferta por tiempo limitado
            </p>
          </div>
        </div>
      </div>
    </section>;
}